export enum ScheduleType {
  InPerson = "InPerson",
  Virtual = "Virtual",
}
